import { Form, FormItemProps, Select } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import classNames from "clsx";

import { SelectInputOption, SelectModeEnum, SizeEnum } from "@/types";
import { REQUIRED_VALIDATION_MESSAGE } from "@/utils/constant";

interface SelectInputProps extends FormItemProps {
  name: string;
  label?: string;
  placeholder: string;
  size?: SizeEnum;
  mode?: SelectModeEnum;
  loading?: boolean;
  options?: SelectInputOption[];
  required?: boolean;
  disabled?: boolean;
  hideClear?: boolean;
  isSeperator?: boolean;
  onChangeListener?: (val: string | number) => void;
  onSelectListener?: (val: string | number, option: SelectInputOption) => void;
  onClearListener?: () => void;
}

export const SelectInput = ({
  name,
  label,
  placeholder,
  size = SizeEnum.large,
  mode,
  loading = false,
  options = [],
  required = false,
  hideClear = false,
  isSeperator = false,
  onChangeListener,
  onSelectListener,
  onClearListener,
  rules = [],
  ...rest
}: SelectInputProps) => {
  const getRules = () => {
    return [...rules, { required, message: REQUIRED_VALIDATION_MESSAGE }];
  };

  return (
    <div
      className={classNames(
        "custom_form_comp_wrapper",
        rest?.hidden && "h-0 overflow-hidden",
        isSeperator && "flex items-center gap-x-2"
      )}
    >
      {label && (
        <label
          htmlFor={name}
          className={classNames(
            "block text-primary-0 ",
            isSeperator ? "mb-6" : "mb-2"
          )}
        >
          {label}
        </label>
      )}
      {isSeperator && (
        <div className="mb-6 flex-[1] basis-24 border border-dashed border-disabled" />
      )}
      <div className={classNames(isSeperator && "basis-[288px]")}>
        <Form.Item name={name} rules={getRules()} {...rest}>
          <Select
            size={size as SizeType}
            placeholder={placeholder}
            mode={mode}
            loading={loading}
            options={options}
            disabled={rest?.disabled}
            allowClear={!hideClear}
            onChange={onChangeListener}
            onSelect={onSelectListener}
            onClear={onClearListener}
            className="bg-neutral-150 rounded text-sm placeholder:text-[#62748E80]/80 border-[#F8FAFC] focus:border-primary-500"
          />
        </Form.Item>
      </div>
    </div>
  );
};
